import { render, staticRenderFns } from "./PcNews.vue?vue&type=template&id=bf22f5de&scoped=true"
import script from "./PcNews.vue?vue&type=script&lang=js"
export * from "./PcNews.vue?vue&type=script&lang=js"
import style0 from "./PcNews.vue?vue&type=style&index=0&id=bf22f5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf22f5de",
  null
  
)

export default component.exports